import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";

class PayementRHService {
  payEmployeTotalOrAvance(payEmploye) {
    return api.post(
      UtilsUrl.rhURL() + "/payement/payEmployeTotalOrAvance",
      payEmploye
    );
  }


  payEmployeSalaryTotalOrAvance(payEmploye) {
    return api.post(
      UtilsUrl.rhURL() + "/payement/payEmployeSalaryTotalOrAvance",
      payEmploye
    );
  }
  getListPayementEmployeBySociete(idUser, month, year) {
    return api.get(
      UtilsUrl.rhURL() +
        "/payement/getListPayementEmployeBySociete/" +
        idUser +
        "/" +
        month +
        "/" +
        year
    );
  }

  getSalaireBySociete(idUser, month, year) {
    return api.get(
      UtilsUrl.rhURL() +
        "/ficheDePaie/getSalaireBySociete/" +
        month +
        "/" +
        year +
        "/" +
        idUser
    );
  }

  getPayementEmployeSalaireBySociete(idUser, idSalaire, month, year) {
    return api.get(
      UtilsUrl.rhURL() +
        "/payement/getPayementEmployeSalaireBySociete/" +
        idUser +
        "/" +
        idSalaire +
        "/" +
        month +
        "/" +
        year
    );
  }
}
export default new PayementRHService();
